import { UserID } from "models";

export type CompanyID = number;

export type EmailImporterID = number;

export type APIKeyID = number;

export type APIKeyLogID = number;

export enum IMPORTER_STATUS {
  First = 1,
  Active = 1,
  Revoked = 2,
  Last = 2
}

export enum API_KEY_STATUS {
  First = 1,
  Active = 1,
  Revoked = 2,
  Last = 2
}

export enum API_KEY_TYPES {
  First = 1,
  Read = 1,
  Write = 2,
  Last = 2
}

export enum API_KEY_LOG_TYPES {
  First = 1,
  Revoke = 1,
  Show = 2,
  Last = 2
}

export interface Company {
  created_on: string;
  id: CompanyID; // Identifier of the company
  name: string; // Name of the company
}

export interface EmailImporter {
  created_on: string;
  updated_on: string;
  id: EmailImporterID; // Identifier of the importer
  email: string; // Email of the company
  company: CompanyID; // Identifier of the company
  name: string; // Name of importer
  phone: string; // Phone of company
  token: string; // Import token of company
  status: IMPORTER_STATUS; // Importer status
}

export interface APIKey {
  created_on: string;
  updated_on: string;
  id: APIKeyID; // Identifier of the key
  type: API_KEY_TYPES; // Whether the API key is for reading or writing
  request_count: number; // The number of requests in the current time (for rate limiting)
  request_count_expires_at: string | null; // Till when the request count is valid (for rate limiting)
  name: string; // Name of the key
  email: string; // Contact email for the key
  phone_number: string; // Contact phone number for the key
  user_id: UserID; // The user that created this key
  company_id: CompanyID; // References to the company
  status: API_KEY_STATUS; // API key status
  created_by_name: string | null; // Name of the user that created the APIKey
  company_name: string | null; // Name of company that owns the APIKey
}

export interface APIKeyLog {
  created_on: string;
  id: APIKeyLogID; // Identifier of the log
  api_key_id: APIKeyID; // The APIKey the log is for
  type: API_KEY_LOG_TYPES; // Type of the log
  reason: string; // Reason provided by the user to show the key
  user_id: UserID; // Identifier of the user that did revoke or show the APIKey
  username: string | null; // Name of the user that did revoke or show the APIKey
}
